import React, { useState } from "react";
import OpportunityDetail from "./opportunity";

import { Alert } from "@/components/ui/alert";
import { XIcon } from "lucide-react";

const SharedOpportunityLayout = ({ children }: any) => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1 p-8 bg-gray-50 flex flex-col gap-4">
        {children}
      </main>
    </div>
  );
};

const LoginHintTop = () => {
  const [closed, setClosed] = useState(false);

  if (!closed) {
    return (
      <Alert className="flex flex-row justify-between items-start">
        <div className="flex flex-col gap-2">
          <p>
            You're currently logged in as a guest user!
          </p>
          <p>
            To see all detected issues and savings opportunities, <a className="underline text-thalo-blue"
                                                                                 href="/">sign in to Copilot</a>.
          </p>
        </div>
        <button onClick={() => setClosed(true)}><XIcon/></button>
      </Alert>
    )
  }
}

const LoginHintBottom = () => (
  <Alert className="flex flex-col gap-2">
    <p>
      You're currently logged in as a guest user!
    </p>
    <p>
      To see all detected issues and savings opportunities, <a className="underline text-thalo-blue"
                                                                           href="/">sign in to Copilot</a>.
    </p>
  </Alert>
)

const SharedOpportunityDetail = ({ token }: { token: string }) => {
  return (
    <SharedOpportunityLayout>
      <LoginHintTop/>
      <OpportunityDetail sharedToken={token}/>
      <LoginHintBottom/>
    </SharedOpportunityLayout>
  );
};

export default SharedOpportunityDetail;